<!-- w-[15rem] -->
<div class="overflow-hidden rounded-xl card-item-1 shadow-sm border border-solid bg-white w-[15.5rem]">
  <div class="w-full object-cover h-44 dark-overlay" [class.h-48]="type === 2"></div>
  
  <!-- card's title -->
  <div class="flex flex-col gap-3 my-3 px-3">
    <div class="flex flex-col gap-1">
        <iho-skeleton height="1.25rem" width="10rem" />

        <div class="flex items-center gap-2">
            <iho-skeleton height="1rem" width="1rem" />
            <iho-skeleton height="1rem" width="6rem" />
          </div>
        <iho-skeleton height="1rem" width="5rem" />
    </div>

    <!-- card's optional part -->

    <div *ngIf="type === 2" class="flex flex-col gap-1">


      <div class="flex w-100 items-center gap-2">
        <iho-skeleton height="2rem" width="2rem" />

        <div class="flex flex-col gap-1">
            <iho-skeleton height="1rem" width="5rem" />
            <iho-skeleton height="1rem" width="7rem" />
        </div>
      </div>
    </div>

    
    <!-- card's footer -->
    <div class="flex flex-col gap-2 items-end w-full">
        <div class="flex w-full items-center gap-1 justify-end">
            <iho-skeleton height="1rem" width="5rem" />
            <iho-skeleton height="2rem" width="2rem" />
        </div>
    
    
        <iho-skeleton height="1.5rem" width="7rem"/>
        
    </div>


  </div>
</div>